export default {"src":"/_next/static/media/digikala.03655012.svg","height":30,"width":115,"blurWidth":0,"blurHeight":0};